import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingComponent } from './landing.component';
import { QuickLinksComponent } from './quick-links/quick-links.component';

@NgModule({
  imports: [CommonModule, QuickLinksComponent],
  declarations: [LandingComponent],
})
export class LandingModule {}
